import React from "react"
import { connect } from "react-redux"
import { Container, Row, Col } from "reactstrap"
import InfoPopup from "../global/infoPopup"

const LearnMore = ({ mobile, logoTheme }) => {
  return (
    <Container fluid>
      <Row id="learnMore" className={`bg-${logoTheme}`}>
        <Col className="d-flex justify-content-start align-items-center">
          <h1 className={`text-${logoTheme === "black" ? "white" : "black"}`}>
            {/* We are a diverse group of individuals focused on helping our clients
            authentically connect with their consumers. We obsess over what
            brands mean to people and how they impact their lives. We stand at
            the crossroads of the conversation and distill that knowledge into
            compelling stories, collaborations, and products. This is the Reed
            Art Department. */}
            Reed Art Department (RAD) is a creative & marketing agency that
            crafts compelling stories, collaborations, and products for
            forward-thinking brands and partners. We have a passion and
            expertise for design, marketing and problem solving, along with an
            innate understanding of storytelling. <br /><br />Our work authentically
            reflects our dedication to our clients, projects, and most
            importantly, our genuine intention to cultivate & grow the culture.
            With over 25 years of experience - we’re not new to this. We are the
            Reed Art Department.
          </h1>
        </Col>
        {mobile && <InfoPopup announcement />}
      </Row>
    </Container>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    logoTheme: state.navbar.logoTheme,
  }),
  null
)(LearnMore)
